import { render, staticRenderFns } from "./QuarterMarksForSubject.vue?vue&type=template&id=a984fa3c&"
import script from "./QuarterMarksForSubject.vue?vue&type=script&lang=js&"
export * from "./QuarterMarksForSubject.vue?vue&type=script&lang=js&"
import style0 from "./QuarterMarksForSubject.vue?vue&type=style&index=0&id=a984fa3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports